import { RootState } from '@reducers';

export const selectPolicyCommissionInvoiceListPageReducer = (state: RootState) => state.userDashboardRouteReducer.policyCommissionInvoiceListPageReducer;
